// extracted by mini-css-extract-plugin
module.exports = {"text":"FinePrint_text__weUi5"};